/* MM / Stories vidéo — assets/mm-video-stories.js
   Zéro code viewer ici : les pastilles se mappent en items du viewer
   stories PARTAGÉ (window.MmStoryViewer, exposé par mm-video-slider.js —
   partage du 31/07, jamais de duplication). Idempotent (garde
   data-mm-vstories-ready) : les previews ré-exécutent les scripts. */
   (function () {
	'use strict';
  
	function init(root) {
	  if (root.dataset.mmVstoriesReady === 'true') return;
  
	  var buttons = Array.prototype.slice.call(root.querySelectorAll('.mm-vstories__item'));
	  if (!buttons.length) return;
  
	  var items = buttons.map(function (btn) {
		var img = btn.querySelector('img');
		var label = btn.querySelector('.mm-vstories__label');
		return {
		  poster: img ? img.src : '',
		  video: btn.getAttribute('data-video') || null,
		  duration: parseInt(btn.getAttribute('data-duration'), 10) || 8,
		  author: label ? label.textContent : '',
		  caption: '',
		  avatar: null
		};
	  });
  
	  /* garde à la MmMotion : sans le viewer partagé, les pastilles restent
		 inertes plutôt que de casser (page sans mm-video-slider.js).
		 Le drapeau « prêt » n'est posé QU'APRÈS ce test : si le viewer n'est
		 pas encore exposé (scripts en defer — mm-video-slider.js peut arriver
		 après nous), un setup() ultérieur doit pouvoir reprendre la main. */
	  var story = window.MmStoryViewer && window.MmStoryViewer.create(items);
	  if (!story) return;
  
	  root.dataset.mmVstoriesReady = 'true';
  
	  buttons.forEach(function (btn, i) {
		btn.addEventListener('click', function () { story.open(i); });
	  });
	}
  
	function setup(scope) {
	  (scope || document).querySelectorAll('.mm-vstories').forEach(init);
	}
  
	window.MmVideoStories = { setup: setup };
  
	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', function () { setup(); });
	} else {
	  setup();
	}
	/* seconde passe quand tous les assets sont là : en defer, le viewer
	   partagé peut être exposé après nous (init sans effet, garde non posée) */
	window.addEventListener('load', function () { setup(); });
  })();